import React from "react";
import './index.css';

const CarSlide = ({carProperty}) => {
    return (
        <div className="car-slider__slide">
            <img src={require(`../../../../image/${carProperty.carImage}`)} alt=""/>
        </div>
    );
}
export default CarSlide;